import React, { useEffect } from 'react'
import { useLazyQuery } from "@apollo/react-hooks";
import { UPDATE_USER_QUERY } from '../../constants/graphql-query';
import { Form, Input, Button, Row, Col, message } from 'antd';

const UpdateProfileForm = (props) => {
	const [updateProfile] = useLazyQuery(UPDATE_USER_QUERY, {
    fetchPolicy: 'no-cache',
		errorPolicy: 'all',
		onCompleted: ( data ) => {
			if (data.updateProfile) {
				message.destroy();
				message.success('Profile Updated Successfully');
			}
		},
		onError: (error) => {
			message.destroy();
			message.error('"Something went wrong !"');
		}
	});
	
	const userProfileData = props.data;

	useEffect(() => {
		if (userProfileData && userProfileData.user) {
			let userDetails = userProfileData.user;
			props.form.setFieldsValue({
				'id': userDetails.userId,
				'Email': userDetails.logonId,
				'first-name': userDetails.firstName,
				'last-name': userDetails.lastName,
				'organization': userDetails.organization,
				'country': userDetails.country
			});
		}
	}, [userProfileData,props.form]);

	const { getFieldDecorator } = props.form;

	const config = (input, extRules = []) => ({
		rules: [].concat(extRules, [
			{ required: true, message: `Please Enter ${input}` },
			extRules
		]),
	});

	const handleSubmit = e => {
		e.preventDefault();

		props.form.validateFields((err, fieldsValue) => {
			if (err) {
				return;
			}
			message.loading('Updating.. Please wait..', 0);
			updateProfile({
				variables: {
					id: userProfileData.user.id,
					firstName: fieldsValue["first-name"],
					lastName: fieldsValue["last-name"],
					country: fieldsValue["country"],
					organization: fieldsValue["organization"]
				}
			})
		});
	};

	return (
		<Form layout="vertical" className="update-profile-form" onSubmit={handleSubmit}>
			<Row gutter={[16, 16]}>
				<Col span={12}>
					<Form.Item label="First Name:">
						{
							getFieldDecorator(
								'first-name',
								config(
									'First Name',
									[{
										type: "string",
										pattern: /^[a-z0-9A-Z\s\w_-]+$/,
										message: 'Please enter valid Input',
									}]
								)
							)(<Input autoComplete="off" />)
						}
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item label="Last Name:">
						{
							getFieldDecorator(
								'last-name',
								config(
									'Last Name',
									[{
										type: "string",
										pattern: /^[a-z0-9A-Z\s\w_-]+$/,
										message: 'Please enter valid Input',
									}]
								)
							)(<Input autoComplete="off" />)
						}
					</Form.Item>
				</Col>
				<Col span={24}>
					<Form.Item label="Email:">
						{
							getFieldDecorator('Email', config('Email'))(<Input disabled={true} />)}
					</Form.Item>
				</Col>
				<Col span={24}>
					<Form.Item label="Country:">
						{
							getFieldDecorator(
								'country',
								config(
									'Country',
									[{
										type: "string",
										pattern: /^[a-z0-9A-Z\s\w_-]+$/,
										message: 'Please enter valid Input',
									}]
								)
							)(<Input autoComplete="off" />)
						}
					</Form.Item>
				</Col>
				<Col span={24}>
					<Form.Item label="Organization:">
						{
							getFieldDecorator(
								'organization',
								config(
									'Organization',
									[{
										type: "string",
										pattern: /^[a-z0-9A-Z\s\w_-]+$/,
										message: 'Please enter valid Input',
									}]
								)
							)(<Input autoComplete="off" />)}
					</Form.Item>
				</Col>
				<Col span={24}>
					<Form.Item>
						<Button type="primary" htmlType="submit" className="primary-dark">Update Profile</Button>
					</Form.Item>
				</Col>
			</Row>
		</Form>
	)
}

const UpdateProfileWithForm = Form.create({ name: 'userProfileUpdateWithForm' })(UpdateProfileForm);

export default UpdateProfileWithForm;